import {ajaxSetup} from "./ajax-config";
import {setupAdTakeover, setupStickOnMobile} from "./ads-stick-on-mobile";
import {setupAdHeroTakeover} from "./ad-hero-takeover";
import {setupCarLaunch} from "./car-launch";
import {setupCarLaunchCalendar} from "./car-launch-calendar";
import {setupCarReviewSearch} from "./car-review-search";
import {setupCarLaunchGallery} from "./car-launch-gallery";
import {setupCarReviewSection} from "./car-review-section";
import {setupCarsLandingPage} from "./cars-landing-page";
import { setupCarStatsPage } from "./car-stats-page";
import { setupAirIndexVehiclePage } from "./air-index-vehicle";
import {setupCommenting} from "./commenting";
import { setupCompareList } from "./compare-list";
import { setupAirIndexCompareList } from "./air-index-compare-list";
import {setupCountdowns} from "./countdown";
import {setupDealsPage} from "./deals-page";
import {setupFaqSearch} from "./faq";
import {setupFleetManagement} from "./fleet-management";
import {setupFleetToolsWidget} from "./fleet-tools-widget";
import {setupFleetNewsUserData} from "./fleetnews-user-data";
import { setupFN200 } from "./fn200";
import { setupBibblio } from "./bibblio";
import { setupCompanySearch } from "./fleet200-company-page";
import { setupFleet200Testimonials } from "./fleet200-testimonials";
import {setupFuelCostCalculator} from "./fuel-cost-calculator";
import {setupFuelTypeButtons} from "./fuel-type-buttons";
import {setupGallery} from "./gallery";
import {setupJobsSearch} from "./jobs";
import {setupJQueryCheckbox} from "./jquery-checkbox";
import {setupMain} from "./main";
import {setupNewCarTaxCalculator} from "./new-car-tax-calculator";
import {setupNewFuelCostCalculator} from "./new-fuel-cost-calculator";
import { setupNewCarRunningCosts } from "./new-running-cost";
import { setupAirIndexTool } from "./air-index-tool";
import { setupElectricVehicles } from "./electric-vehicles";
import {setupRegionalFuelPrices} from "./regional-fuel-prices";
import {setupSupplierZone} from "./supplier-zone";
import {setupTestDriveTeaser} from "./test-drive-teaser";
import {setupUpsoldCarLaunch} from "./upsold-car-launch";
import {setupVanCO2Calculator} from "./van-co2-calculator";
import {setupVanCompareList} from "./van-compare-list";
import {setupVanReviewSearch} from "./van-review-search";
import {setupVanReviews} from "./van-reviews";
import {setupVanReviewManufacturers} from "./van-reviews-manufacturers-dropdown";
import {setupVanRunningCosts} from "./van-running-costs";
import {setupWhatIsMyCarMPG} from "./what-is-my-car-mpg";
import {setupCarCO2Calculator} from "./car-co2-calculator";
import {setupFleetNewsAccount} from "./account";
import { setupVansLandingPage } from "./vans-landing-page";
import { setupCarReview } from "./car-review";
import { setupDieselCostCalculator } from "./diesel-cost-calculator";
import { setupOneLinkNewVehicles } from "./epyx-data";
import {setupEWIFSlider} from "./ewif-testimonials";


ajaxSetup();

function needsGoogleCharts() {
    const pageType = $("#PageType").val();
    const chartPages = ['OneLinkNewVehicles', 'OneLinkAverageVehicleWorkshopLeadTime', 'OneLinkAverageAgeOfFleetEnteringWorkshop', 'OneLinkAverageFleetVehicleDowntime'];
    return chartPages.includes(pageType);
}

$(() => {
    //Ignore datatable alert messages (errors)
    $.fn.dataTable.ext.errMode = 'none';
    setupFleetNewsAccount();
    setupStickOnMobile();
    setupAdHeroTakeover();
    setupCarCO2Calculator();
    setupCarLaunch();
    setupCarLaunchCalendar();
    setupCarLaunchGallery();
    setupCarReviewSearch();
    setupCarReviewSection();
    setupCarsLandingPage();
    setupCarStatsPage();
    setupAirIndexVehiclePage();
    setupCommenting();
    setupCompareList();
    setupAirIndexCompareList();
    setupCountdowns();
    setupDealsPage();
    setupFaqSearch();
    setupFleetManagement();
    setupFleetToolsWidget();
    setupFleetNewsUserData();
    setupFN200();
    setupCompanySearch();
    setupFleet200Testimonials();
    setupEWIFSlider();
    // setupFuelCostCalculator();
    // setupFuelTypeButtons();
    setupGallery(); 
    setupJobsSearch();
    setupJQueryCheckbox();
    setupMain();
    setupNewCarTaxCalculator();
    setupNewFuelCostCalculator();
    setupNewCarRunningCosts();
    setupAirIndexTool();
    setupElectricVehicles();
    setupRegionalFuelPrices();
    setupSupplierZone();
    setupTestDriveTeaser();
    setupUpsoldCarLaunch();
    setupVanCO2Calculator();
    setupVanCompareList();
    setupVanReviewSearch();
    setupVanReviews();
    setupVanReviewManufacturers();
    setupVanRunningCosts();
    setupWhatIsMyCarMPG();
    setupBibblio();
    setupVansLandingPage();
    setupCarReview();
    setupDieselCostCalculator();
    if (needsGoogleCharts()) {
        const pageType = $("#PageType").val(); // Get the value of hidden field
        if (pageType === 'OneLinkNewVehicles') {
            setupOneLinkNewVehicles();
        } else if (pageType === 'OneLinkAverageVehicleWorkshopLeadTime') {
            setupOneLinkAverageLeadTimes();
        }
        else if (pageType === 'OneLinkAverageAgeOfFleetEnteringWorkshop') {
            setupOneLinkAverageAgeOfFleet();
        }
        else if (pageType === 'OneLinkAverageFleetVehicleDowntime') {
            setupOneLinkAverageFleetVehicleDowntime();
        }
    }

    const qrCodeDataElement = document.getElementById("qrCodeData");
    if (qrCodeDataElement) {
        const uri = qrCodeDataElement.getAttribute('data-url');
        new QRCode(document.getElementById("qrCode"), {
            text: uri,
            width: 150,
            height: 150
        });
    }
});
